module.exports = __webpack_public_path__ + "static/img/son12_active.b0d7f04a.jpg";